import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Phone, RefreshCw } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";

const CURRENCY_DIAL = { KWD: "965", SAR: "966", AED: "971", BHD: "973", QAR: "974", OMR: "968", GBP: "44", USD: "1", EUR: "33" };

export const PhoneDialog = ({ open, onOpenChange, currency, onSubmit, busy }) => {
  const { t } = useTranslation();
  const [cc, setCc] = useState(CURRENCY_DIAL[currency] || "965");
  const [num, setNum] = useState("");
  const valid = cc.length >= 1 && num.length >= 5;

  const submit = (e) => {
    e.preventDefault();
    if (!valid || busy) return;
    onSubmit({ country_code: cc, number: num });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" style={{ background: "#161616", border: "1px solid #2a2a2a" }} data-testid="phone-dialog">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <Phone className="w-4 h-4 text-purple-400" /> {t("billing.phone.title")}
          </DialogTitle>
          <DialogDescription style={{ color: "#8a8a8a" }}>{t("billing.phone.body")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2" dir="ltr">
          <div className="flex gap-3">
            <label className="w-28">
              <span className="block text-[11px] uppercase tracking-wider mb-1" style={{ color: "#6b6b6b" }}>{t("billing.phone.countryCode")}</span>
              <div className="flex items-center rounded-xl px-3" style={{ background: "#0e0e0e", border: "1px solid #333" }}>
                <span className="text-sm" style={{ color: "#8a8a8a" }}>+</span>
                <input value={cc} inputMode="numeric" maxLength={4}
                  onChange={(e) => setCc(e.target.value.replace(/\D/g, ""))}
                  data-testid="phone-country-code-input"
                  className="w-full bg-transparent py-2.5 pl-1 text-sm text-white font-bold outline-none" />
              </div>
            </label>
            <label className="flex-1">
              <span className="block text-[11px] uppercase tracking-wider mb-1" style={{ color: "#6b6b6b" }}>{t("billing.phone.number")}</span>
              <input value={num} inputMode="numeric" maxLength={15} autoFocus
                onChange={(e) => setNum(e.target.value.replace(/\D/g, ""))}
                data-testid="phone-number-input"
                className="w-full rounded-xl px-3 py-2.5 text-sm text-white font-bold outline-none"
                style={{ background: "#0e0e0e", border: "1px solid #333", caretColor: "#c084fc" }} />
            </label>
          </div>
          <button type="submit" disabled={!valid || busy} data-testid="phone-save-btn"
            className="w-full py-3 rounded-xl text-sm font-bold flex items-center justify-center gap-2 disabled:opacity-50"
            style={{ background: "#7c3aed", color: "#fff" }}>
            {busy && <RefreshCw className="w-3.5 h-3.5 animate-spin" />} {t("billing.phone.save")}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
